import React, { useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import FeedOptions from "../FeedOptions/FeedOptions";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import SnackbarHandler from "src/Utils/SnackbarHandler";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import EndPoints from "src/Constants/EndPoints";
import { Link, useRouteMatch } from "react-router-dom";
import ReactLinkify from "react-linkify";
// import i18n from 'src/locales/i18n';
// import 'moment/locale/fr'; 
// import 'moment/locale/en-gb'; 
// moment.locale(`${i18n.language}`)
import ReactPlayer from 'react-player';


function FeedItem(props: any) {
  
  const { user } = AppStateHandler.getState();
  const { path } = useRouteMatch();
  const { t, i18n } = useTranslation();
  const {
    toggleLike,
    refetch,
    setPostData,
    setModalVisibility,
    setReportData,
    setShowReportModal,
    ...item
  } = props;
  const {
    id,
    groupId,
    user_name,
    user_image,
    timestamp,
    images,
    type,
    subId,
    title,
    message,
    likes,
    total_comments,
    sale_price,
    is_like,
    is_bookmark,
  } = props;
  const route = path === "/groups/:id" ? "/groups/" + groupId : path;
  const url = message?.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
  
  const [activeIndex, setActiveIndex] = useState(0);
  const [like, { status: likeStatus }] = useApiMutation({
    onSettled: () => {
      refetch();
    },
  });

  const likePost = async () => {
    if (likeStatus === "loading") {
      return;
    }
    if (user.username === subId || !user.username) {
      
      SnackbarHandler.likeErrorToast("You can't like your own post.");
      return;
    }
    try {
      await like({
        url: EndPoints.likePost,
        data: {
          subId: user?.username,
          postId: id,
          groupId: groupId,
        },
      });
      toggleLike();
    } catch (error) {
      toggleLike();
    }
  };

  return (
    <div className="post mb-2 post_feed">
      <div className="px-3 d-flex">
        <div className={`m${i18n.dir()==='rtl'?'l':'r'}-3`}>
          <img
            src={
              user_image !== ""
                ? user_image
                : "/assets/images/profile-camera.png"
            }
            className="rounded-circle img-fluid feed_img"
            alt=""
            style={{ height: 40, width: 40 }}
          />
        </div>
        <div className="d-flex align-items-center justify-content-between w-90">
          <div>
            <h3 className="fz16 poppinssemibold mb-0">{user_name}</h3>
            <p className={`fz10 mb-0 poppinsregular text-secondary ${i18n.dir()==='rtl'?'text-right Almaraisemibold':''}`}>
              <span className="ml-0">
                {/* {i18n.language} */}
                {timestamp ? moment(new Date(timestamp)).fromNow() : ""}
              </span>
            </p>
          </div>
          <FeedOptions
            id={id}
            groupId={groupId}
            subId={subId}
            is_bookmark={is_bookmark}
            refetch={refetch}
            data={item}
            setPostData={setPostData}
            setModalVisibility={setModalVisibility}
            setReportData={setReportData}
            setShowReportModal={setShowReportModal}
          />
        </div>
      </div>
      <div className="">
        <div className="slider_section my-4">
          <div
            id="demo"
            className="carousel slide"
            data-ride="carousel"
            data-interval="30000000"
          >
            <ul className="carousel-indicators">
              {(Array.isArray(images) ? images : []).map(
                (_: any, _i: number) => (
                  <li
                    className={_i === activeIndex ? "active" : ""}
                    data-target="#demo"
                    key={_i}
                    data-slide-to={_i}
                    onClick={() => setActiveIndex(_i)}
                  ></li>
                )
              )}
            </ul>
            <div className="carousel-inner">
              {(Array.isArray(images) ? images : []).map(
                ({ url }: any, _i: number) => (
                  <div
                    key={_i}
                    className={`carousel-item text-center ${_i === activeIndex ? "active" : ""
                      }`}
                  >
                    <Link to={route + "/" + item.id} className="d-inline-block">
                      <img
                        src={url}
                        key={_i}
                        alt="Los Angeles"
                        className="img-fluid post-img w-100 cursor-pointer"
                      />
                    </Link>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <div className="px-3 cursor-pointer">
          
            <Link to={route + "/" + item.id}>
              <ReactLinkify>
                <p className={`mb-0 fz16  post_message ${i18n.dir() === "rtl"  ? "Almaraisemibold text-right" : "poppinsregular"}`}>
                  {type === "SALE" ? title : message}
                </p>
              </ReactLinkify>
            </Link>
            {ReactPlayer.canPlay(url)	 &&  <ReactPlayer url={url} width={'100%'}/>}
        </div>
        <VisibilityToggle visible={type === "SALE"}>
          <div className={"px-3 d-flex"}>
            <VisibilityToggle visible={sale_price === "0"}>
              <p className="mb-0 text-secondary fz12 poppinsregular">Free</p>
            </VisibilityToggle>
            <VisibilityToggle visible={sale_price !== "0"}>
              <p className="mb-0 text-secondary fz12 poppinsregular">
                DZD {sale_price}
              </p>
              &nbsp;
            </VisibilityToggle>
          </div>
        </VisibilityToggle>
        <VisibilityToggle visible={type !== "SALE"}>
          <div className="px-3">
            <hr />
          </div>
          <div className="post_list px-3">
            <ul className={`list-unstyled d-flex mb-0 ${i18n.dir()==='rtl'?'pr-0':''}`}>
              <li className = {`${i18n.dir()==='rtl'?'post_li_rtl':'post_li_ltr'}`}>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    likePost();
                  }}
                >
                  <i
                    className={`fa ${is_like ? "fa-heart text-danger" : "fa-heart-o base_color" 
                      } ${i18n.dir()==='rtl'?'post_li_i_rtl':'post_li_i_ltr'}`}
                    aria-hidden="true"
                  ></i>
                  {likes ?? 0}
                </a>
              </li>
              <li>
                <Link to={route + "/" + item.id}>
                  <i
                    className={`fa fa-comment-o base_color ${i18n.dir()==='rtl'?'post_li_i_rtl':'post_li_i_ltr'}`}
                    aria-hidden="true"
                  ></i>
                  {total_comments ?? 0}
                </Link>
              </li>
            </ul>
          </div>
        </VisibilityToggle>
      </div>
    </div>
  );
}

export default FeedItem;
